export default __webpack_public_path__ + "static/media/sketch.aee3d173.png";